import * as React from 'react';
import { Bem, addClass } from '../../utils';
import { Icon } from '../Icon/Icon';
import { useId } from '../../utils/hooks/useId';
import './HeaderMenuItem.css';
const bem = Bem.create('vai-header-menu-item');
export const HeaderMenuItem = (props) => {
    const { component = 'div', children, onClick, iconColor, iconName, htmlId, dataTa, className, innerRef, ...rest } = props;
    const id = useId(htmlId, ['header dropdown item']);
    const renderIcon = (id, iconName, iconColor) => {
        if (iconName) {
            return React.createElement(Icon, { htmlId: id.toHtmlId(), className: bem.element('icon')(), name: iconName, color: iconColor });
        }
        return null;
    };
    const Component = component;
    return (React.createElement(Component, Object.assign({ ref: innerRef, id: id.toString(), "data-ta": dataTa, className: addClass(bem.block(props.iconName && 'with-icon'), className), onClick: onClick, role: "menuitem" }, rest),
        renderIcon(id, iconName, iconColor),
        React.createElement("span", { className: bem.element('children')() }, children)));
};
//# sourceMappingURL=HeaderMenuItem.js.map